// extracted by mini-css-extract-plugin
export default {"container":"uKamo74p","overlay":"g1PDMn4f","overlayTop":"sqmGjvfw","overlayContentTop":"sTEhpjn7","overlayContent":"YK7fyAjk","radiusWrapper":"wEtkO5SZ","slider":"dwQAGY05"};